// Choose_Us.jsx
import React from "react";
import "./Choose_Us.css";
import Heading_title from "../../common-components/common-title/heading-title/Heading_title";
import { Container, Row, Col } from "react-bootstrap";

const Choose_Us = () => {
  return (
    <section className="choose_us">
      <Container>
        <Heading_title
          title={"Why Choose Us"}
          subtitle={
            "List upcoming sports events, tournaments, or fitness challenges with dates and registration"
          }
        />

        <Row className="justify-content-center">
          {/* cards 1 */}
          <Col sm={6} md={4} className="mb-4">
            <div className="cards">
              <img
                src="/assets/images/about_us/choose_us/certifications.png"
                alt="Certified Coaches & Trainers"
                className="cards-img"
              />
              <div className="caption">Certified Coaches & Trainers</div>
            </div>
          </Col>

          {/* cards 2 */}
          <Col sm={6} md={4} className="mb-4">
            <div className="cards">
              <img
                src="/assets/images/about_us/choose_us/community.png"
                alt="Inclusive Programs"
                className="cards-img"
              />
              <div className="caption">Inclusive Programs</div>
            </div>
          </Col>

          {/* cards 3 */}
          <Col sm={6} md={4} className="mb-4">
            <div className="cards">
              <img
                src="/assets/images/about_us/choose_us/sports.png"
                alt="Community Spirit"
                className="cards-img"
              />
              <div className="caption">Community Spirit</div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Choose_Us;
